import React from 'react';
function SmallRightArrow({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 8.25L13.75 12 10 15.75" />
    </svg>
  );
}

export default SmallRightArrow;
